import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { IDealProject } from '../types';

const getDealSubprojects = async (dealId: number): Promise<Array<IDealProject>> => {
    const response = await axiosInstance.get(API_ENDPOINTS.DEAL_SUBPROJECTS(dealId));
    return response.data;
};

export const useGetDealSubprojects = (dealId: number) => useQuery({
    queryKey: [QUERY_KEYS.DEAL_SUBPROJECTS, dealId],
    queryFn: () => getDealSubprojects(dealId),
    staleTime: 5000,
    refetchOnMount: true,
    enabled: !!dealId,
});

export default useGetDealSubprojects;
